import { onBeforeUnmount, onMounted, watch } from 'vue'

export const PAGE_HEAD_HEIGHT_VARIABLE = '--ds-page-head-height'

/**
 * Publishes the height of the sticky headline row (title, breadcrumbs, bell, user menu) as
 * `--ds-page-head-height` on the document, so a page's own sticky toolbar can sit right below it
 * (`top: var(--ds-page-head-height, 0px)`) instead of sliding under it. The headline never
 * scrolls (theme.css); its height changes when the breadcrumb trail wraps.
 *
 * @param {import('vue').Ref<HTMLElement|null>} element the headline row
 */
export function useStickyPageHead(element) {
  let observer = null

  const publish = (target) => {
    document.documentElement.style.setProperty(
      PAGE_HEAD_HEIGHT_VARIABLE,
      `${target.getBoundingClientRect().height}px`,
    )
  }

  const observe = (target) => {
    observer?.disconnect()
    observer = null

    if (!target) {
      return
    }

    publish(target)

    if (typeof ResizeObserver === 'function') {
      observer = new ResizeObserver(() => publish(target))
      observer.observe(target)
    }
  }

  onMounted(() => {
    observe(element.value)
    watch(element, observe)
  })

  onBeforeUnmount(() => {
    observer?.disconnect()
    document.documentElement.style.removeProperty(PAGE_HEAD_HEIGHT_VARIABLE)
  })
}
